import React from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel
} from '@material-ui/core'
import Modal from 'react-bootstrap/Modal'
import { Button } from 'reactstrap'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  textfield: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.23)'
    }
  }
})

const ApplicantModal = ({
  show,
  setShow,
  handleClose,
  status,
  testResult,
  setTestResult,
  languageLevel,
  setLanguageLevel,
  testPassability,
  setTestPassability,
  newStatus,
  setNewStatus,
  description,
  setDescription,
  error,
  setError,
  changeApplicantStatus,
  buttonsApplicants,
  sendDirectToTesting,
  setSendDirectToTesting
}) => {
  const classes = useStyles()

  const onNumberInputWheel = (e) => {
    try {
      if (e && e.target && e.target.blur) e.target.blur()
    } catch (err) {}
  }

  const onNumberInputFocus = (e) => {
    try {
      const el = e && e.target
      if (el && el.addEventListener) el.addEventListener('wheel', onNumberInputWheel, { passive: true })
    } catch (err) {}
  }

  const onNumberInputBlur = (e) => {
    try {
      const el = e && e.target
      if (el && el.removeEventListener) el.removeEventListener('wheel', onNumberInputWheel)
    } catch (err) {}
  }

  return (
    <Modal show={show} onHide={handleClose} className='modal-1'>
      <Modal.Header closeButton>
        <Modal.Title>{status === 'waiting_list' || status === 'failed' ? 'Test results' : 'Description'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {status === 'waiting_list' || status === 'failed' ? (
          <>
            <TextField
              className={classes.textfield}
              fullWidth
              placeholder
              type='number'
              label='Test scores'
              variant='outlined'
              laceholder='Test scores'
              onChange={(e) => setTestResult(e.target.value)}
              value={testResult}
            />
            <FormControl variant='outlined' fullWidth className={classes.textfield} style={{ marginTop: '20px' }}>
              <InputLabel id='language_level_label'>Language level</InputLabel>
              <Select
                label='Language level'
                labelId='language_level'
                id='language_level_select'
                value={languageLevel}
                onChange={(e) => setLanguageLevel(e.target.value)}
              >
                <ListSubheader>Level A</ListSubheader>
                <MenuItem value='A1'>A1</MenuItem>
                <MenuItem value='A2'>A2</MenuItem>
                <ListSubheader>Level B</ListSubheader>
                <MenuItem value='B1'>B1</MenuItem>
                <MenuItem value='B2'>B2</MenuItem>
                <ListSubheader>Level C</ListSubheader>
                <MenuItem value='C1'>C1</MenuItem>
                <MenuItem value='C2'>C2</MenuItem>
              </Select>
            </FormControl>
            <FormControl variant='outlined' fullWidth className={classes.textfield} style={{ marginTop: '20px' }}>
              <InputLabel id='test_passability_label'>Test pass rate</InputLabel>
              <Select
                label='Test pass rate'
                labelId='test_passability'
                id='test_passability_select'
                value={testPassability}
                onChange={(e) => setTestPassability(e.target.value)}
              >
                <MenuItem value={true}>Positives</MenuItem>
                <MenuItem value={false}>Negative</MenuItem>
              </Select>
            </FormControl>
            <FormControl disabled variant='outlined' fullWidth className={classes.textfield} style={{ marginTop: 20 }}>
              <InputLabel id='next_status_label'>Next Status</InputLabel>
              <Select
                labelId='next_status_label'
                id='next_status_select'
                value={status === 'failed' ? 'failed' : 'waiting_list'}
                onChange={(e) => setNewStatus(e.target.value)}
                label='Statusi i ardhshëm'
              >
                <MenuItem value={status === 'failed' ? 'failed' : 'waiting_list'}>{status === 'failed' ? 'Failed' : 'Passed'}</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant='outlined'
              placeholder='Write the reason!'
              className={classes.textfield}
              style={{ marginTop: '20px', marginBottom: '30px' }}
              fullWidth
              multiline
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </>
        ) : (
          <>
            <TextField
              variant='outlined'
              placeholder='Write the reason!'
              className={classes.textfield}
              fullWidth
              multiline
              style={{ marginBottom: '30px' }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            {status === 'will_be_tested' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendDirectToTesting || false}
                    onChange={(e) => {
                      setSendDirectToTesting(e.target.checked)
                      if (e.target.checked) {
                        setNewStatus('testing')
                      }
                    }}
                    color='primary'
                  />
                }
                label='Send directly to testing'
                style={{ marginBottom: '20px' }}
              />
            )}
          </>
        )}
        {status !== 'new' && (
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            {error && (
              <Typography className='mt-2 mb-2 text-danger' style={{ fontSize: '14px' }}>
                All data must be filled in!
              </Typography>
            )}
            <Button
              color='info'
              onClick={() => {
                if (!description) {
                  setError(true)
                } else if (
                  (status === 'waiting_list' || status === 'failed') &&
                  (!description || !testResult || !languageLevel || testPassability == undefined || !newStatus)
                ) {
                  setError(true)
                } else {
                  setError(false)
                  setShow(false)
                  changeApplicantStatus()
                  setDescription('')
                }
              }}
            >
              {buttonsApplicants.filter((btn) => btn.type === status)[0].text}
            </Button>
          </Box>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ApplicantModal
